import { Link } from "react-router-dom";
import { formatDate } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

const FooterHeading = ({ children }) => <h3 className="text-white font-heading font-bold uppercase text-sm tracking-wider mb-4 border-l-4 border-red-600 pl-3">{children}</h3>;

const STATIC_LINKS = [
  ["/podcast", "Podcast"],
  ["/magazine", "Magazine"],
  ["/chronique", "Chronique de la semaine"],
];

export const FooterRubriques = () => {
  const { navCategories } = useSettings();
  const links = [...navCategories.map((c) => [`/rubrique/${c.slug}`, c.name]), ...STATIC_LINKS];
  return (
  <div>
    <FooterHeading>Rubriques</FooterHeading>
    <ul className="space-y-2 text-sm">
      {links.map(([to, label]) => <li key={to}><Link to={to} className="hover:text-red-500 transition-colors">{label}</Link></li>)}
    </ul>
  </div>
  );
};

export const FooterRecent = ({ recent }) => (
  <div>
    <FooterHeading>Dernières actus</FooterHeading>
    <ul className="space-y-3">
      {recent.map((a) => (
        <li key={a.id}>
          <Link to={`/article/${a.slug}`} className="text-sm font-semibold text-zinc-200 hover:text-red-500 transition-colors line-clamp-2">{a.title}</Link>
          <div className="text-xs text-zinc-500 mt-0.5">{formatDate(a.published_at)}</div>
        </li>
      ))}
    </ul>
  </div>
);

export { FooterHeading };
